import React from 'react';
import { Facebook, Instagram, Linkedin, MapPin, MessageCircle } from 'lucide-react';
import { SOCIAL_PROFILES } from '../seo/socialProfile';

// DPA-4 — shared official social-identity links. Renders the ratified profiles (Google Business,
// Facebook, Instagram, LinkedIn, WhatsApp) as icon links, from the single source `seo/socialProfile`.
// Presentation only. External links open in a new tab; `rel="me"` declares the site↔profile identity
// relationship (complements the JSON-LD `sameAs`). Returns a bare list of <a> elements — the caller
// provides the flex/section wrapper (footer row, contact section, about section).
//
// `tone`: 'dark' (on the black footer) | 'light' (on white contact/about surfaces).
const ICONS = { google: MapPin, facebook: Facebook, instagram: Instagram, linkedin: Linkedin, whatsapp: MessageCircle };

export default function SocialLinks({ tone = 'light' }) {
  const cls =
    tone === 'dark'
      ? 'w-10 h-10 bg-black border border-white/10 rounded-xl flex items-center justify-center text-white/50 hover:text-white hover:border-white/20 transition-all'
      : 'w-11 h-11 bg-black rounded-xl flex items-center justify-center text-white hover:bg-neutral-800 transition-colors';
  return SOCIAL_PROFILES.map((s) => {
    const Icon = ICONS[s.key];
    return (
      <a
        key={s.key}
        href={s.url}
        target="_blank"
        rel="me noopener noreferrer"
        aria-label={s.label}
        title={s.label}
        className={cls}
        data-testid={`social-${s.key}`}
      >
        <Icon className="w-5 h-5" aria-hidden="true" />
      </a>
    );
  });
}
